import "./MenuPhone.css";
import { IconButton, List, ListItem, ListItemText, } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ApiNavigation, ApiNavigationType } from "enum/api";
import { IMenuItem } from "./MenuProps";
import { FnAxios } from "utilities/utilities";
import MenuOpenRoundedIcon from '@mui/icons-material/MenuOpenRounded';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import { ProviderLayout } from "../Homepage";
import MenuItemsPhone from "../MenuItem";

const MenuBarHome = () => {
    const AxiosFn = FnAxios();

    const {
        IsMenuOpen,
        setIsMenuOpen,
        IsOverMouse,
        setIsOverMouse,
        isMouseOver,
        open,
        setOpen
    } = useContext(ProviderLayout);

    const [arrData, setMenu] = useState<IMenuItem[]>([]);

    useEffect(() => {
        let result: IMenuItem[] = [];
        AxiosFn.Get(ApiNavigation.GetMenu, { nMenuType: ApiNavigationType.FrontEndTop }, (d) => {
            result = d.objResultHome;
            setMenu([...result]);
        })
    }, []);

    const handleDrawerClose = () => {
        setOpen(!open)
        setIsMenuOpen(!IsMenuOpen);
    }

    const HandleOverMenu = () => {
        if (!IsMenuOpen && isMouseOver) {
            setIsMenuOpen(true)
            setIsOverMouse(true)
        }
    }

    const HandleLeaveMenu = () => {
        if (IsOverMouse && isMouseOver) {
            setIsMenuOpen(false)
            setIsOverMouse(false)
        }
    }

    const {
        Layout630,
    } = useContext(ProviderLayout);

    return (
        <List
            component="nav"
            className="nav-menu"
            subheader={
                <ListItem className="nav-menu-burger" style={{ justifyContent: 'center', display: Layout630 ? "" : "none" }}>
                    {IsMenuOpen ? <ListItemText primary={"Menu"} className="icon-menu" /> : null}
                    <IconButton onClick={handleDrawerClose}>
                        {IsMenuOpen ? <MenuOpenRoundedIcon className="icon-menu" /> : <MenuRoundedIcon className="icon-menu" />}
                    </IconButton>
                </ListItem>
            }
        >
            <div
                onMouseOver={HandleOverMenu}
                onMouseLeave={HandleLeaveMenu}
            >
                {
                    arrData.map((item) => {
                        let sMenuID = "menu-" + item.nMenuID;
                        return (
                            <MenuItemsPhone key={sMenuID} {...item}></MenuItemsPhone>)
                    })
                }
            </div>
        </List>
    )
}
export default MenuBarHome;
